/**
 * @file toolbar-tags.tsx
 * @description Компонент отображения активных фильтров в виде тегов для toolbar таблиц в Task Manager приложении. Предоставляет интерфейс для визуализации примененных фильтров через Tag компоненты с возможностью индивидуального удаления каждого фильтра или массовой очистки всех активных фильтров через кнопку "Очистить всё". Элементы реализованы через компоненты Tag и Button.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-01-16
 * @dependencies ['@components/ui/indicators/tag', '@consta/uikit/Button']
 * @related-files ['src/components/ui/indicators/tag/tag.component.tsx']
 */

import { Tag } from '@components/ui/indicators/tag';
import { Button } from '@consta/uikit/Button';

export const ToolbarTags = ({ filters, onFilterClick, onClearFilters }: any) => {
    return (
        <div className="filter-tag-line flex flex-row flex-wrap items-center mb-[1.482vmin] gap-[0.8472vmin]">
            {filters.map((filter: any, key: number) => (
                <Tag
                    title={filter.title}
                    key={key}
                    mode="button"
                    onClick={() => onFilterClick(filter)}
                    onTagClose={() => onClearFilters(filter.name)}
                />
            ))}

            {filters.length > 1 && (
                <Button
                    className="text-link hover:!text-link-hover h-[2.1171vmin] text-[1.0585vmin] leading-[2.1171vmin] px-[0.4226vmin]"
                    view="clear"
                    label="Очистить всё"
                    size="xs"
                    onClick={() => onClearFilters()}
                />
            )}
        </div>
    );
};